module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_3016.c7fb8abe.png";